import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";
import { smallLarge } from "./iconConstants";

const printIcons = {
  small: ({ color, children, ...props }) => (
    <svg
      {...props}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <g>
            <rect x="0" y="0" width="16" height="16" />
            <path
              d="M12.5,3 L9.5,3 C9.22385763,3 9,2.77614237 9,2.5 L9,1 L4,1 L4,2.5 C4,2.77614237 3.77614237,3 3.5,3 C3.22385763,3 3,2.77614237 3,2.5 L3,0.5 C3,0.223857625 3.22385763,-5.86197757e-14 3.5,-5.86197757e-14 L10.5,-5.86197757e-14 C10.6326082,-5.86197757e-14 10.7597852,0.0526784202 10.8535534,0.146446609 L12.8535534,2.14644661 C13.0488155,2.34170876 13.0488155,2.65829124 12.8535534,2.85355339 C12.7559223,2.95118446 12.6279612,3 12.5,3 Z M11.2928932,2 L10.2928932,1 L10,1 L10,2 L11.2928932,2 Z M4,13 L2.5,13 C1.11696918,13 7.99360578e-14,11.8871288 7.99360578e-14,10.5018986 L7.99360578e-14,6.49810135 C7.99360578e-14,5.11927853 1.1164151,4 2.49188419,4 L13.5081158,4 C14.8871076,4 16,5.11332718 16,6.49810135 L16,10.5018986 C16,11.8840345 14.885945,13 13.5,13 L12,13 L12,15.5 C12,15.7761424 11.7761424,16 11.5,16 L4.5,16 C4.22385763,16 4,15.7761424 4,15.5 L4,13 Z M12,12 L13.5,12 C14.3332764,12 15,11.332133 15,10.5018986 L15,6.49810135 C15,5.66552451 14.3347354,5 13.5081158,5 L2.49188419,5 C1.66927409,5 1,5.67099067 1,6.49810135 L1,10.5018986 C1,11.3340195 1.66843281,12 2.5,12 L4,12 L4,10.5 C4,10.2238576 4.22385763,10 4.5,10 L11.5,10 C11.7761424,10 12,10.2238576 12,10.5 L12,12 Z M5,15 L11,15 L11,11 L5,11 L5,15 Z M2.5,8 C2.22385763,8 2,7.77614237 2,7.5 C2,7.22385763 2.22385763,7 2.5,7 L4.5,7 C4.77614237,7 5,7.22385763 5,7.5 C5,7.77614237 4.77614237,8 4.5,8 L2.5,8 Z"
              {...color !== "currentColor" && { fillOpacity: ".65" }}
              fill={color}
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  large: ({ color, children, ...props }) => (
    <svg
      {...props}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-274.000000, -187.000000)">
          <g transform="translate(274.000000, 187.000000)">
            <g>
              <rect x="0" y="0" width="24" height="24" />
              <path
                d="M5,17 L2.5,17 C1.12385763,17 0,15.8761424 0,14.5 L0,8.5 C0,7.12316384 1.12355127,6 2.5,6 L21.5,6 C22.8764487,6 24,7.12316384 24,8.5 L24,14.5 C24,15.8761424 22.8761424,17 21.5,17 L19,17 L19,23.5 C19,23.7761424 18.7761424,24 18.5,24 L5.5,24 C5.22385763,24 5,23.7761424 5,23.5 L5,17 Z M19,16 L21.5,16 C22.3238576,16 23,15.3238576 23,14.5 L23,8.5 C23,7.67552581 22.3242412,7 21.5,7 L2.5,7 C1.67575883,7 1,7.67552581 1,8.5 L1,14.5 C1,15.3238576 1.67614237,16 2.5,16 L5,16 L5,13.5 C5,13.2238576 5.22385763,13 5.5,13 L18.5,13 C18.7761424,13 19,13.2238576 19,13.5 L19,16 Z M6,1 L6,4.5 C6,4.77614237 5.77614237,5 5.5,5 C5.22385763,5 5,4.77614237 5,4.5 L5,0.5 C5,0.223857625 5.22385763,0 5.5,0 L15.5,0 C15.6326082,0 15.7597852,0.0526784202 15.8535534,0.146446609 L18.8535534,3.14644661 C18.9473216,3.2402148 19,3.36739176 19,3.5 L19,4.5 C19,4.77614237 18.7761424,5 18.5,5 C18.2238576,5 18,4.77614237 18,4.5 L18,3.70710678 L15.2928932,1 L6,1 Z M6,23 L18,23 L18,14 L6,14 L6,23 Z M5,10.5 C5,10.2231424 4.77685763,10 4.5,10 C4.22371954,10 4,10.223565 4,10.5 C4,10.7758576 4.22414237,11 4.5,11 C4.77643497,11 5,10.7762805 5,10.5 Z M6,10.5 C6,11.3284106 5.32887443,12 4.5,12 C3.67185763,12 3,11.3281424 3,10.5 C3,9.67112557 3.67158938,9 4.5,9 C5.32914237,9 6,9.67085763 6,10.5 Z M16,3 L18.5,3 C18.7761424,3 19,3.22385763 19,3.5 C19,3.77614237 18.7761424,4 18.5,4 L15.5,4 C15.2238576,4 15,3.77614237 15,3.5 L15,0.5 C15,0.223857625 15.2238576,0 15.5,0 C15.7761424,0 16,0.223857625 16,0.5 L16,3 Z"
                fill={color}
                {...color !== "currentColor" && { fillOpacity: ".65" }}
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
};

const PrintIcon = ({ size, ...rest }) => printIcons[size](rest);

PrintIcon.displayName = "PrintIcon";

PrintIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  size: PropTypes.oneOf(smallLarge)
};

PrintIcon.defaultProps = {
  children: null,
  color: themes.global.gray01,
  size: smallLarge[0]
};

export default PrintIcon;
